import CheckboxField from '@/components/ui/Form/inputs/Checkbox';
import Button from '@/components/Common/Button';
import FeatureFlag from '@/components/util/FeatureFlag';
import { useState } from 'react';

export const AttributionDescription = () => {
  const [showMoreMessage, setShowMoreMessage] = useState(false);

  return (
    <>
      User must record at least one attribution event before purchasing.{' '}
      {showMoreMessage && (
        <>
          <br className="mb-2" />
          Requiring attribution events ensures that users are only rewarded for
          offers that they have seen. If attribution events for a user are not
          being sent to Kard via the{' '}
          <a
            href="https://docs.getkard.com/api/attributions/create-attribution-events"
            target="_blank"
            rel="noreferrer"
            className="underline hover:text-primary"
          >
            Attributions API
          </a>
          , they will not be able to redeem offers that require attribution.{' '}
        </>
      )}
      <Button
        className="text-[1em]"
        variant="text"
        onClick={() => {
          setShowMoreMessage((prev) => !prev);
        }}
      >
        {showMoreMessage ? 'Less...' : 'More...'}
      </Button>
    </>
  );
};

type AttributionFieldProps = {
  isEditing?: boolean;
};

const AttributionField = ({ isEditing }: AttributionFieldProps) => (
  <FeatureFlag flag="portal-offers-attribution-settings">
    {(flagValue) => {
      if (!flagValue.enabled) {
        return null;
      }

      return (
        <CheckboxField
          label="Attribution Required"
          name="attribution.isRequired"
          disabled={!isEditing}
          className="max-w-[500px]"
          description={<AttributionDescription />}
        />
      );
    }}
  </FeatureFlag>
);

export default AttributionField;
